/**
 * Network quality types.
 */
export enum QualityType {
  /**
   * The downlink network quality.
   *
   * It is calculated based on the uplink transmission bitrate, uplink packet loss rate, RTT (round-trip time) and jitter.
   *
   * - 0: The quality is unknown.
   * - 1: The quality is excellent.
   * - 2: The quality is good, but the bitrate is less than optimal.
   * - 3: Users experience slightly impaired communication.
   * - 4: Users can communicate with each other, but not very smoothly.
   * - 5: The quality is so poor that users can barely communicate.
   * - 6: The network is disconnected and users cannot communicate.
   */

  QualityUnknown = 0,
  QualityExcellent = 1,
  QualityGood = 2,
  QualityNormal = 3,
  QualityBad = 4,
  QualityPoor = 5,
  QualityDisconnected = 6,
}
